import { callApi } from 'services/api/utils'

import { AutoCompleteData, AutoCompleteOption } from './AutoComplete.model'

const AUTOCOMPLETE_ENDPOINT_PATH = 'admin/autocomplete'

export async function autoCompleteSearch(
  query: string,
  dataType: string,
  dataLength: number = 10
): Promise<AutoCompleteData> {
  const data = await callApi<AutoCompleteOption[]>({
    method: 'get',
    url: AUTOCOMPLETE_ENDPOINT_PATH,
    params: {
      query,
      entity: dataType,
    },
  })

  return {
    currentPage: 1,
    count: data.length,
    type: dataType,
    data: data.splice(0, dataLength),
  }
}
